import { render, staticRenderFns } from "./QuizResults.vue?vue&type=template&id=3a029f7e&scoped=true"
import script from "./QuizResults.vue?vue&type=script&lang=js"
export * from "./QuizResults.vue?vue&type=script&lang=js"
import style0 from "./QuizResults.vue?vue&type=style&index=0&id=3a029f7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a029f7e",
  null
  
)

export default component.exports